"use strict";
var Observable_1 = require("../../Observable");
var bufferWhen_1 = require("../../operator/bufferWhen");
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/bufferWhen.js
 ** module id = 269
 ** module chunks = 1
 **/